import type { HTMLComponent } from "@commercekit/react";
import { CKFormHiddenInputs, useFormHiddenInputs } from "@commercekit/ui";

const WvFormHiddenInputs: HTMLComponent<{
  data: Record<string, string | number | boolean | undefined>;
}> = ({ data }) => {
  const _data = useFormHiddenInputs(data);
  return <CKFormHiddenInputs data={_data} />;
};

export default WvFormHiddenInputs;
